export class Device {
  deviceAddress: string;
  safePeerAddress: string;
  deviceName: string;
  deviceStatus: string;
  type: string;
}
